





































































import {Component, PropSync, Watch} from 'vue-property-decorator'
  import {Getter, Action} from "vuex-class";
  import BaseFilter from "@/components/Filter/BaseFilter";
  import {PartnerFilter} from "@/store/settings/partners/types";
  import {SelectWings, ToggleWings, NumberWings, InputWings} from "wings-ui-components";
  import {notifyError} from "@/utils/notify-helper";
  import {getTranslatedParams} from "@/utils/notify-utils";

  @Component({components: {SelectWings, ToggleWings, NumberWings, InputWings}})
  export default class PartnersFilter extends BaseFilter<PartnerFilter>{
    @PropSync('filterProp') filterParent!: any;
    @PropSync('runFilter') run!: any;
    @PropSync('show') is_show!: boolean;
    @Getter("transports") transportsList: any;
    @Action("getPartners") actionGetPartners: any;
    @Action("getTransports") actionGetTransports: any;
    @Action("exportPartners") actionExportPartners: any;
    statusList:number[] = [1,0];

    defaultFilter(): PartnerFilter {
      return {
        id: undefined,
        name: undefined,
        transport: undefined,
        status: undefined,
        page_number: 1
      }
    }

    created() {
      this.actionGetTransports();
      this.filtered();
      this.scroll();
    }

    async onFilteredAction(nextPage = false) {
      if (!nextPage) this.filter.page_number = 1;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Client",
          addititional_info: getTranslatedParams(this.filter)
        };
        const resp = await this.actionGetPartners(this.filter);
        await this.actionLog(this.logObject);
        this.is_last = resp.length == 0;
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(err);
      } finally {
        this.moreLoading = false;
      }
    }

    export(): void {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Export",
        action_status: "success",
        object_type: "Client",
        addititional_info: getTranslatedParams(this.filter)
      }
      this.actionExportPartners(this.filter).then(() => {
        this.actionLog(this.logObject);
      }).catch((error: any) => {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error)
      })
    }

    get transportsForPartners() {
      return this.transportsList.filter((value:any) => value.name.toLowerCase() !== 'ussd')
    }

    @Watch('filter', {immediate: true, deep: true})
    onFilterChanged(val: PartnerFilter) {
      this.filterParent = val;
    }

    @Watch('run')
    onRunFilter(val: boolean) {
      if (!val) return;
      this.filtered();
      this.run = false;
    }
  }
